module.exports = __webpack_public_path__ + "static/media/cohort_logo.877588c0.PNG";